var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "v-input v-input__select",
        _vm.isDirty ? "v-input--is-dirty" : "",
        _vm.disabled ? "v-input--is-disabled" : "",
        _vm.selectToggleState ? "v-input__select--is-open" : "",
        !!_vm.errors.has(_vm.newName) ? "v-input__error--border" : ""
      ],
      attrs: { "data-vv-value-path": "model", "data-vv-as": _vm.label }
    },
    [
      _vm.label
        ? _c("label", { staticClass: "v-input__label" }, [
            _vm._v(_vm._s(_vm.label))
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.form || _vm.form.length === 0
        ? _c("Select2", {
            staticClass: "v-select-search",
            attrs: {
              name: _vm.name,
              id: _vm.id,
              disabled: _vm.disabled,
              index: _vm.index,
              settings: {
                containerCssClass:
                  "v-input__field fontawesome-select" +
                  (_vm.selectToggleState ? " v-input__select--is-open" : "") +
                  (_vm.showCreate ? " select-show-create-link" : ""),
                dropdownAutoWidth: true
              },
              options: _vm.orderedOptions
            },
            on: {
              blur: _vm.setSelectFalse,
              mouseup: _vm.toggleSelect,
              change: function($event) {
                _vm.$emit("input", _vm.model),
                  _vm.toggleSelect,
                  _vm.$emit("change", _vm.model)
              }
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          })
        : _c("Select2", {
            staticClass: "v-select-search",
            attrs: {
              form: _vm.form,
              name: _vm.name,
              id: _vm.id,
              disabled: _vm.disabled,
              index: _vm.index,
              settings: {
                containerCssClass:
                  "v-input__field fontawesome-select" +
                  (_vm.selectToggleState ? " v-input__select--is-open" : "") +
                  (_vm.showCreate ? " select-show-create-link" : ""),
                dropdownAutoWidth: true
              },
              options: _vm.orderedOptions
            },
            on: {
              blur: _vm.setSelectFalse,
              mouseup: _vm.toggleSelect,
              change: function($event) {
                _vm.$emit("input", _vm.model),
                  _vm.toggleSelect,
                  _vm.$emit("change", _vm.model)
              }
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          }),
      _vm._v(" "),
      _vm.showCreate
        ? _c(
            "v-modal-link",
            {
              staticStyle: {
                position: "absolute",
                top: "3px",
                right: "0px",
                width: "25px",
                height: "100%"
              },
              attrs: { href: _vm.createUrl },
              on: {
                "get-result": function($event) {
                  return _vm.getCurrentItem($event)
                }
              }
            },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons",
                  staticStyle: { "padding-top": "10px" }
                },
                [_vm._v("add")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.has(_vm.newName)
        ? _c("div", { staticClass: "v-input__error" }, [
            _vm._v("\n    " + _vm._s(_vm.errors.first(_vm.newName)) + "\n  ")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5863ce3f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5863ce3f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VSelectSearch.vue
// module id = 287
// module chunks = 1 2